/**
 * 集合页面滚动渐变效果
 * 滚动时同时改变标题大小和描述透明度，最终定位在facets-container中间
 */
class CollectionScrollEffect {
  constructor() {
    this.titleDescriptionElement = document.querySelector('.collection-title-description');
    this.titleElement = document.querySelector('.collection-title');
    this.descriptionElement = document.querySelector('.collection-description');
    this.facetsContainer = document.querySelector('.facets-container');
    // if (!this.titleDescriptionElement || !this.titleElement || !this.descriptionElement || !this.facetsContainer) {
      return;
    // }
    this.initTitleSize = parseFloat(window.getComputedStyle(this.titleElement).fontSize)


    // 获取标题元素和facets容器的位置信息
    this.titleRect = this.titleDescriptionElement.getBoundingClientRect();
    this.facetsRect = this.facetsContainer.getBoundingClientRect();



    // 初始值
    this.initialTitleSize = this.initTitleSize; // px
    this.finalTitleSize = 20; // px
    this.initialDescriptionOpacity = 1;
    this.finalDescriptionOpacity = 0;

    // 移动端适配
    this.isMobile = window.innerWidth <= 749;
    if (this.isMobile) {
      this.finalTitleSize = 16; // px
    }

    this.translateYValue = this.facetsRect.top - this.titleRect.top - (this.initTitleSize - this.finalTitleSize);
    const topValue = window.innerWidth <= 1100 ? 10 : 15;
    this.titleDescriptionElement.style.top = document.querySelector('.header-wrapper').clientHeight + topValue - this.translateYValue + 'px';

    if (this.titleDescriptionElement && this.facetsContainer) {
      this.init();
    }
  }

  init() {
    // 绑定滚动事件
    this.bindScrollEvent();

    // 初始检查滚动位置
    this.handleScroll();
  }

  bindScrollEvent() {
    let ticking = false;

    const handleScrollEvent = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScrollEvent, { passive: true });

    // 监听窗口大小变化
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth <= 749;
      if (this.isMobile) {
        this.finalTitleSize = 16; // px
      } else {
        this.finalTitleSize = 20; // px
      }
      this.handleScroll();
    });
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // 从标题开始位置到facets容器中心位置的距离作为滚动范围
    const titleOriginalTop = this.titleRect.top + scrollTop;
    const facetsCenterY = this.facetsRect.top + scrollTop + (this.facetsRect.height / 2);

    // 计算滚动进度 (0到1之间)
    const scrollDistance = facetsCenterY - titleOriginalTop;
    const progress = Math.min(Math.max(scrollTop / scrollDistance, 0), 1);

    // 根据进度计算当前的样式值
    this.updateStyles(progress);

    // 当到达facets容器中心时，调整标题位置
    // if (progress >= 0.9) {
    //   this.positionTitleAtFacetsCenter();
    // }
  }

  updateStyles(progress) {
    if (!this.titleElement) return;

    // 计算标题字体大小 (线性插值)
    const currentTitleSize = this.initialTitleSize - (this.initialTitleSize - this.finalTitleSize) * progress;
    this.titleElement.style.fontSize = `${currentTitleSize}px`;

    // 计算描述透明度
    if (this.descriptionElement) {
      const currentOpacity = this.initialDescriptionOpacity - (this.initialDescriptionOpacity - this.finalDescriptionOpacity) * progress;
      this.descriptionElement.style.opacity = currentOpacity < 0.5 ? 0 : currentOpacity;
    }
    // 计算标题位置
    this.titleDescriptionElement.style.transform = `translateY(${this.translateYValue * progress}px)`;

    // 添加或移除CSS类以便进行额外的样式控制
    if (progress > 0.8) {
      this.titleDescriptionElement.classList.add('at-facets');
    } else {
      this.titleDescriptionElement.classList.remove('at-facets');
    }
  }

  positionTitleAtFacetsCenter() {
    const facetsRect = this.facetsContainer.getBoundingClientRect();
    const titleRect = this.titleDescriptionElement.getBoundingClientRect();

    // 计算需要移动的距离，使标题居中对齐到facets容器
    const facetsCenterY = facetsRect.top + (facetsRect.height / 2);
    const titleCenterY = titleRect.top + (titleRect.height / 2);
    const offsetY = facetsCenterY - titleCenterY;

    // 应用变换，但保持在合理范围内
    const maxOffset = 100; // 最大偏移量
    const clampedOffset = Math.min(Math.max(offsetY, -maxOffset), maxOffset);

    this.titleDescriptionElement.style.transform = `translateY(${clampedOffset}px)`;
  }

  // 公共方法：销毁实例
  destroy() {
    if (this.titleDescriptionElement) {
      this.titleDescriptionElement.classList.remove('at-facets');
      this.titleDescriptionElement.style.transform = '';
    }

    if (this.titleElement) {
      this.titleElement.style.fontSize = '';
    }

    if (this.descriptionElement) {
      this.descriptionElement.style.opacity = '';
    }
  }
}

// 当DOM加载完成后初始化
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.main-collection-product-grid')) {
    window.scrollTo(0, 0);
    window.collectionScrollEffect = new CollectionScrollEffect();
  }
});